import React, {Component, lazy, Suspense} from 'react';

import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Header from "./components/layout/Header";
import Loader from "./components/Loader";
import Footer from "./components/layout/Footer";
import MetaTags from "./components/MetaTags";
import User from "./classes/User";
import Api from "./api/Api";
import Analytics from "./components/Analytics";
import Popunder from "./components/ads/Popunder";

const Home = lazy(() => import("./views/Home"));
const Image = lazy(() => import("./views/Image"));
const Images = lazy(() => import("./views/Images"));
const Videos = lazy(() => import("./views/Videos"));
const Video = lazy(() => import("./views/Video"));
const Galleries = lazy(() => import("./views/Galleries"));
const Gallery = lazy(() => import("./views/Gallery"));
const Tag = lazy(() => import("./views/Tag"));
const Search = lazy(() => import("./views/Search"));
const UserCallback = lazy(() => import("./views/UserCallback"));
const Contact = lazy(() => import("./views/Contact"));
const Profile = lazy(() => import("./views/Profile"));
const Favorites = lazy(() => import("./views/Favorites"));
const Cams = lazy(() => import("./views/Cams"));
const Cam = lazy(() => import("./views/Cam"));
const Subscriptions = lazy(() => import("./views/Subscriptions"));
const Tags = lazy(() => import("./views/Tags"));

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    window.user = new User();
    Api.status().then(res => {
      this.setState({
        loading: false
      })
    });
  }

  render() {
    const { loading } = this.state;

    if (loading) {
      return <Loader/>;
    }

    return (
      <Router>
        <HelmetProvider>
          <Analytics/>
          <MetaTags />
          <Popunder />

          <div id={'app'}>
            <Header />

            <div className={'content-area'}>
              <Suspense fallback={<Loader />}>
                <Switch>
                  <Route path={"/user/callback"} render={() => { return <UserCallback /> }} />

                  <Route path="/(image|gif)/:section/:tag/:slug" render={() => { return (<Image />) }} />
                  <Route path="/(image|gif)/:section/:slug" render={() => { return (<Image />) }} />
                  <Route path="/(image|gif)/:slug" render={() => { return (<Image />) }} />

                  <Route path="/images/:section/:tag" render={() => { return (<Images />) }} />
                  <Route path="/images/:section" render={() => { return (<Images />) }} />
                  <Route path="/images" exact={true} render={() => { return (<Images />) }} />

                  <Route path="/video/:section/:tag/:slug" render={() => { return (<Video />) }} />
                  <Route path="/video/:section/:slug" render={() => { return (<Video />) }} />
                  <Route path="/video/:slug" exact={true} render={() => { return (<Video />) }} />

                  <Route path="/videos/:section/:tag" render={() => { return (<Videos />) }} />
                  <Route path="/videos/:section" render={() => { return (<Videos />) }} />
                  <Route path="/videos" exact={true} render={() => { return (<Videos />) }} />

                  <Route path="/gallery/:section/:tag/:slug" render={() => { return (<Gallery />) }} />
                  <Route path="/gallery/:section/:slug" render={() => { return (<Gallery />) }} />
                  <Route path="/gallery/:slug" exact={true} render={() => { return (<Gallery />) }} />

                  <Route path="/galleries/:section/:tag" render={() => { return (<Galleries />) }} />
                  <Route path="/galleries/:section" render={() => { return (<Galleries />) }} />
                  <Route path="/galleries" exact={true} render={() => { return (<Galleries />) }} />

                  <Route path="/tag/:slug" exact={true} render={() => { return (<Tag />) }} />
                  <Route path="/tags" exact={true} render={() => { return (<Tags />) }} />

                  <Route path="/cam/:slug" exact={true} render={() => { return (<Cam />) }} />
                  <Route path="/cams" exact={true} render={() => { return (<Cams />) }} />

                  <Route path="/search" exact={true} render={() => { return (<Search />) }} />

                  <Route path="/contact" exact={true} render={() => { return (<Contact />) }} />

                  <Route path="/user/subscriptions/:sort" exact={true} render={() => { return (<Subscriptions />) }} />
                  <Route path="/user/favorites" exact={true} render={() => { return (<Favorites />) }} />
                  <Route path="/user" exact={true} render={() => { return (<Profile />) }} />

                  <Route path="/" exact={true} render={() => { return (<Home />) }} />
                </Switch>
              </Suspense>
            </div>

            <Footer/>
          </div>
        </HelmetProvider>
      </Router>
    );
  }
}

export default App;
